module.exports = __webpack_public_path__ + "static/media/icon_pgcode_global_card.7468bc89.svg";